import styled from "styled-components";

export const TeamContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  min-height: 85vh;
  padding: 0;
  background-color: #f7f7f7;
  .navbar {
    width: 100%;
    height: 30vh;
    background: var(--team-primary-color);
    display: flex;
    flex-direction: column;
    border-radius: 0 0 24px 24px;
    .logo {
      width: auto;
      height: 60%;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        height: 100%;
      }
    }
    .navbar-content {
      display: flex;
      flex-direction: column;
      width: calc(100% - 2rem);
      height: 100%;
      justify-content: space-between;
      color: var(--team-secondary-color);
      padding: 0.75rem 1rem;
      h3 {
        margin: 0 auto;
      }
      .header-links-container {
        overflow: scroll;
        width: 100%;
        &::-webkit-scrollbar {
          display: none;
        }
        ul {
          width: fit-content;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          padding: 0;
          margin: 0;
          li {
            list-style: none;
            font-weight: 700;
            padding: 0 1rem;
            a {
              text-decoration: none;
              position: relative;
              color: var(--team-secondary-color);
              &.active::after {
                content: "";
                position: absolute;
                left: 0;
                bottom: -2px;
                width: 100%;
                height: 4px;
                background-color: var(--team-secondary-color);
                border-radius: 2px;
                z-index: 0;
              }
            }
          }
        }
        select {
          border-radius: 1.5rem;
          padding-left: 0.75rem;
          padding-right: 0.75rem;
          height: 2rem;
          width: fit-content;
          -webkit-appearance: none;
        }
      }
    }
  }
  .content {
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-wrap: wrap;
    .standing-table-container,
    .team-stats-table,
    .info-scores,
    .players-slider,
    .teamInformation-table-container {
      width: 100%;
      height: auto;
      border-radius: 24px;
      background: #fff;
      margin-top: 1rem;
      border: 1px solid #ebebeb;
    }
    .info-scores {
      overflow: scroll;
      height: 500px;
    }
    .standing-table-container {
      height: 300px;
      position: relative;
    }
    .players-table-container {
      .players-table-header {
        padding: 0 1rem;
        border-bottom: 4px solid rgb(126, 126, 126);
        .title {
          font-weight: 700;
        }
      }
      .players-table-content-extra {
        width: 100%;
        height: auto;
        display: flex;
        .players-table-content {
          width: 100%;
          display: flex;
          margin-top: 1rem;
          .players-table-info {
            width: 30%;
            .players-table-img-conatiner {
              border-radius: 100%;
              width: 50%;
              overflow: hidden;
              img {
                height: auto;
              }
            }
          }
          .players-table-statistics-container {
            width: 70%;
            flex-direction: column;
            .players-table-statistics-value {
              width: 100%;
              height: 10px;
              background: red;
            }
            .players-table-statistics-data {
              width: 100%;
              display: flex;
              justify-content: space-between;
              p {
                margin-top: 0;
              }
            }
          }
        }
      }
    }
    .team-stats-table {
      margin-bottom: 2rem;
      border-radius: 24px;
      height: auto;
      .matches-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 1rem;
        h2 {
          color: #ff6a00;
        }
        .circle {
          position: relative;
          top: 5px;
          left: 5px;
          text-align: center;
          width: 60px;
          height: 60px;
          border-radius: 100%;
          background-color: #ffffff;
        }
        .circle p {
          position: absolute;
          top: 10%;
          left: 35%;
          cursor: default;
        }
        .circle-border {
          position: relative;
          text-align: center;
          width: 70px;
          height: 70px;
          border-radius: 100%;
          background-color: #e53b3b;
        }
        .hover-information {
          display: none;
          width: 200px;
          height: fit-content;
          padding: 0.5rem;
          border-radius: 24px;
          color: #fff;
          background: #000;
          position: absolute;
          bottom: 100%;
          right: 0;
        }
        .circle-border:hover > .hover-information {
          display: block;
        }
      }
      .stats-table-header {
        width: 100%;
        background: #eee;
        padding: 0.5rem 0;
        text-align: center;
      }
    }
    .leaders-table {
      margin-bottom: 2rem;
      border-radius: 24px;
      height: auto;
      width: calc(100% - 2rem);
      padding: 1rem;
      margin-bottom: 2rem;
      border-radius: 24px;
      background: #fff;
      margin-top: 1rem;
      border: 1px solid #ebebeb;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      table {
        width: 49%;
        margin: 1rem 0;
        thead {
          tr td {
            font-weight: 700;
          }
        }
        tr {
          td {
            font-size: 14px;
            &.value {
              color: #555;
              font-weight: 700;
            }
          }
        }
      }
    }
  }
  .history-container {
    width: 100%;
    margin: auto;
    background: #fff;
    min-height: 85vh;
    .history-header,
    .history-content {
      width: 90%;
      margin: auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      p {
        flex-basis: 10%;
      }
    }
    .history-header {
      font-weight: 700;
    }
    .history-content {
      border-bottom: 1px solid rgb(235 235 235 / 1);
    }
  }
  .team-container {
    width: 100%;
    margin: auto;
    background: #fff;
    min-height: 85vh;
    padding-bottom: 1rem;
    .team-header,
    .player-container {
      display: flex;
      width: 95%;
      margin: 0 auto;
      justify-content: space-between;
      align-items: center;
      p {
        flex-basis: 16%;
      }
    }
    .team-header {
      font-weight: 700;
      p {
        &.up-arrow {
          display: flex;
          align-items: center;
          &::after {
            content: "";
            width: 0;
            height: 0;
            border-left: 7px solid transparent;
            border-right: 7px solid transparent;
            border-bottom: 7px solid green;
          }
        }
        &.down-arrow {
          display: flex;
          align-items: center;
          &::after {
            content: "";
            width: 0;
            height: 0;
            border-left: 7px solid transparent;
            border-right: 7px solid transparent;
            border-top: 7px solid #f00;
          }
        }
      }
    }
    .player-container {
      border-bottom: 1px solid rgb(235 235 235 / 1);
      img {
        width: 25px;
      }
    }
  }
  @media only screen and (min-width: 867px) {
    flex-direction: column;
    padding: 0 2rem;
    width: calc(100% - 4rem);
    .navbar {
      flex-direction: row;
      height: 20vh;
      .logo {
        width: 300px;
      }

      .navbar-content {
        width: calc(100% - 300px);
        padding: 0.75rem 3rem;
        height: auto;
        h3 {
          margin: 0;
        }
        .header-links-container {
          overflow: auto;
          ul {
            width: 60%;
            li {
              padding: 0;
            }
          }
        }
      }
    }
    .content {
      flex-direction: row;
      .standing-table-container,
      .team-stats-table,
      .info-scores,
      .players-slider {
        height: 300px;
        width: 49%;
      }
      .teamInformation-table-container {
        width: 100%;
        height: 150px;
      }
      .team-container .player-container img {
        width: 50px;
      }
      .leaders-table {
        table {
          flex-basis: 30%;
          tr td {
            font-size: 16px;
          }
        }
      }
    }
  }
`;
export const UpgradeContainer = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 85vh;
  h2,
  p {
    width: 80%;
    margin: 1rem auto;
    text-align: center;
  }
  form {
    width: 90vw;
    .form-group {
      display: flex;
      flex-direction: column;
      input {
        padding: 1rem;
        margin: 1rem 0;
        border-radius: 14px;
        border: 1px solid #cccccc;
      }
    }
    .personal-container {
      display: flex;
      flex-direction: column;
      width: 100%;
      .buyer-name {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      .messagge input {
        height: 100px;
      }
    }
  }
  .btns-container {
    display: flex;
    margin: 1rem auto;
  }
`;
